import { Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";

type Props = {
	icon: LucideIcon;
	text: string;
	isLink: boolean;
};

export const AdvisorContactLineContent: FC<Props> = ({
	icon: Icon,
	text,
	isLink,
}) => {
	const theme = useTheme();

	return (
		<>
			<Icon
				size={theme.iconSize.sm}
				color={isLink ? theme.palette.blue[500] : theme.palette.grey[500]}
			/>
			<Typography
				variant="body2"
				color={isLink ? theme.palette.blue[600] : theme.palette.grey[600]}
				sx={{ overflowWrap: "anywhere" }}
			>
				{text}
			</Typography>
		</>
	);
};
